import { MessageService } from "primeng/api";
import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AppComponent } from "../app.component";
import { AuthData } from "../core/data";
import { ForgotPasswordRequest, LoginRequest } from "../core/models";
import { UtilityService } from "../core/services";
import { GtmService, GtmEventName } from "../core/services/shared-services/gtm.service";



@Component({
    selector: "app-forgot",
    templateUrl: "./app.forgot.component.html",
    styleUrls: ["./app.forgot.component.scss"],
    standalone: false
})
export class AppForgotComponent {
    public loginForm: FormGroup;
    public forgotForm: FormGroup;
    private returnUrl: string;
    isBacktoLogin=false;
    showSubmitButtonLoader = false;
    showForgotSubmitButtonLoader = false;
    latestYear: number = new Date().getFullYear();
    constructor(
        public app: AppComponent,
        private authServiceApi: AuthData,
        private route: ActivatedRoute,
        private router: Router,
        private messageService: MessageService,
        private utilityService: UtilityService,
        private gtm: GtmService
    ) {
        this.loginForm = new FormGroup({
            email: new FormControl("", [Validators.required]),
        });

        this.forgotForm = new FormGroup({
            password: new FormControl("", [Validators.required]),
            confirmPassword: new FormControl("", [Validators.required]),
        });
    }
    ngOnInit() {
        this.route.queryParams.subscribe((params) => {
            this.returnUrl = params.returnUrl;
        });
    }

    showChangePassword: boolean = false;

    submit() {
        if (this.loginForm.valid) {
            var email = this.formValues().email;

            this.showSubmitButtonLoader = true;
            this.authServiceApi.forgotPassword(email).subscribe({
                next: (v) => {
                   this.utilityService.shouldAllow.next(v.success)
                    if (
                        v != null &&
                        v.success == true
                    ) {
                        this.router.navigateByUrl("/login");
                        this.messageService.add({
                            severity: "success",
                            summary: "Password Change",
                            detail: "Reset Password link has been sent to your mail box."
                        });

                    }
                    else {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: v?.responseMessage_en ?? "Unable to send reset link. Please try again.",
                        });
                    }

                    this.showSubmitButtonLoader = false;
                },
                error: (e) => {
                    this.showSubmitButtonLoader = false;
                },
            });
        }
    }

    forgotSubmit() {
        if (this.forgotForm.valid) {
            const request: ForgotPasswordRequest = {
                userName: this.formValues().email,
                newPassword: this.formForgotValues().password,
                confirmPassword: this.formForgotValues().confirmPassword,
                flowType: "forgot",
            };

            this.showForgotSubmitButtonLoader = true;
            this.authServiceApi.changePassword(request).subscribe({
                next: (v) => {
                    if (
                        v != null &&
                        v.success == true &&
                        v.data != null &&
                        v.data == true
                    ) {
                        this.gtm.push({ event: GtmEventName.PasswordResetSuccess });
                        this.messageService.add({
                            severity: "success",
                            summary: "Password Change",
                            detail: "Password successfully changed",
                        });
                        this.router.navigate(["login"]);
                    }
                    else {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: v?.responseMessage_en ?? "Unable to change password. Please try again.",
                        });
                    }

                    this.showForgotSubmitButtonLoader = false;
                },
                error: (e) => {
                    this.showForgotSubmitButtonLoader = false;
                },
            });
        }
    }

    formValues() {
        return this.loginForm.value;
    }

    formForgotValues() {
        return this.forgotForm.value;
    }

    showPassword: boolean = false;
    showHidePassword() {
        this.showPassword = !this.showPassword;
    }

    showConfirmPassword: boolean = false;
    showHideConfirmPassword() {
        this.showConfirmPassword = !this.showConfirmPassword;
    }
}
